<template>
  <div class="vehicleModifyDialog">
    <popup v-if="activated">
      <template #title>계기판 촬영</template>

      <template #content>
        <div class="contArea">
          <div class="conTit1 mgb mgt2">현재 차량 주행거리를 입력해주세요.</div>
          <div class="phInput">
            <input type="text" ref="kmStr" v-model="kmStr" ><span>km</span>
          </div>
          <p class="txtInfo mgt1">입력하신 주행거리와 실제 주행거리가 다를 시,<br>서비스 제공에 제한이 있을 수 있습니다.</p>
        </div>
      </template>

      <template #button>
        <span class="button">
          <a v-if="validated" class="fCol1" @click="updateSubsc()">확인</a>
          <a v-else class="fColDisabled">확인</a>
        </span>
      </template>
    </popup>
  </div>
</template>

<script>
import axios from "axios";

import {api} from "../../../../api";
import Popup from "../../../../components/Popup/Popup";

export default {
  components: {
    Popup,
  },

  props: {
    subsc: Object,
  },

  data(){
    return{
      activated: false,
      km: null,
      kmStr: null,
      validated: false,
    }
  },

  watch: {
    kmStr(val) {
      let km = val.replace(/((^0)|[^0-9]|(,))/g, '');
      this.km = km;
      this.kmStr = km.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      this.validated = !(this.km === 0 || this.km === null || this.km === '');
    },
  },

  methods:{
    open(){
      this.kmStr = this.subsc.options.vehicleData.km;
      this.activated = true;
    },

    updateSubsc(){
      this.subsc.options.vehicleData.km = this.km;

      axios.put(`${api.subscs}/${this.subsc.id}`, {options: this.subsc.options})
          .then(() => {
            this.close();
          })
          .catch((error) => {
            if(error.response.status === 401) {
              this.$store.commit('setPopup401', true);
            } else {
              this.alertRoute(this.errorMsg(error));
            }
          });
    },

    close() {
      this.$emit("closed");
    },
  }
}
</script>

<style scoped>

</style>